import React from 'react';

import AdminLayout from 'Pages/Admin/AdminLayout';
import {PollResultsGraph} from 'Components/MainStage';

import Base from 'Pages/MainStage/Base';

export default class LiveResults extends Base {
    /**
     * @var state
     */
    state = {
        currentSession: null,
        currentPoll: null
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.mountBase();
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        this.unmountBase();
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const { currentSession, currentPoll } = this.state;

        return (
            <div className="min-h-screen font-light flex flex-col justify-between bg-black bg-cover bg-top">
                {!currentPoll?.id &&
                    <p className="m-6 font-bold text-center text-white">
                        No live poll running
                    </p>
                }

                {currentPoll?.id &&
                    <PollResultsGraph
                        session_id={currentSession?.id}
                        poll_id={currentPoll?.id}
                    />
                }
            </div>
        );
    }
}
